import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { SERVICES, COMPANY } from "@/lib/site";
import Reveal from "@/components/Reveal";

const NETWORK_IMG = "https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBJVCUyMHN1cHBvcnQlMjBuZXR3b3JrJTIwc2VydmVyJTIwcm9vbXxlbnwwfHx8fDE3ODM0NjU1MDN8MA&ixlib=rb-4.1.0&q=85";
const SURV_IMG = "https://images.pexels.com/photos/19782580/pexels-photo-19782580.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Services() {
  return (
    <div data-testid="services-page">
      {/* HEADER */}
      <section className="bg-white border-b border-[#E5E1DE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#8B4513]">Our Services</span>
            <h1 className="font-heading text-5xl md:text-7xl tracking-tight mt-4 max-w-4xl">
              <span className="font-light">Everything your business</span>{" "}
              <span className="font-black">needs to stay online.</span>
            </h1>
            <p className="mt-8 text-lg md:text-xl text-[#594A42] max-w-2xl leading-relaxed">
              From provisioning and installation to ongoing service, Beta-Tech Systems is your
              single point of contact for business technology in Baton Rouge.
            </p>
          </Reveal>
        </div>
      </section>

      {/* SERVICE BLOCKS */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 space-y-24 md:space-y-32">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const img = i % 2 === 0 ? NETWORK_IMG : SURV_IMG;
          const reverse = i % 2 !== 0;
          return (
            <Reveal key={s.slug}>
              <div
                data-testid={`service-block-${s.slug}`}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${reverse ? "lg:[direction:rtl]" : ""}`}
              >
                <div className="lg:[direction:ltr]">
                  <div className="w-14 h-14 flex items-center justify-center rounded-sm bg-[#00B4C4]/10 text-[#00B4C4]">
                    <Icon className="h-7 w-7" />
                  </div>
                  <h2 className="font-heading text-3xl md:text-5xl font-black tracking-tight mt-6">{s.title}</h2>
                  <p className="mt-5 text-[#594A42] text-lg leading-relaxed">{s.body}</p>
                  <ul className="mt-6 space-y-2">
                    {["Provisioning", "Installation", "Ongoing Service & Support"].map((f) => (
                      <li key={f} className="flex items-center gap-3 text-[#1A110B] font-medium">
                        <CheckCircle2 className="h-5 w-5 text-[#00B4C4]" /> {f}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="lg:[direction:ltr]">
                  <img src={img} alt={s.title} className="w-full h-[360px] object-cover rounded-sm" />
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>

      {/* CTA */}
      <section className="bg-[#2E1605]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-white">Not sure what you need?</h2>
            <p className="text-[#D9CFC8] mt-3 text-lg">Let's talk through your setup and find the right fit.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contact" data-testid="services-cta-contact" className="inline-flex items-center justify-center gap-2 bg-[#FFA500] text-[#1A110B] font-heading font-black tracking-wider uppercase text-sm px-8 py-4 rounded-sm hover:-translate-y-0.5 transition-transform">
              Request a Consultation <ArrowRight className="h-4 w-4" />
            </Link>
            <a href={COMPANY.paymentUrl} target="_blank" rel="noopener noreferrer" data-testid="services-cta-payment" className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white font-heading font-bold tracking-wider uppercase text-sm px-8 py-4 rounded-sm hover:bg-white hover:text-[#1A110B] transition-all">
              Make a Payment
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
